import React from "react";
import AboutMe from "../sections/AboutMe";
import Skills from "../sections/Skills";
import Experience from "../sections/Experience";

function Content() {
  return (
    <main>
      <AboutMe />
      <Skills />
      {/* <Certifications /> */}
      <Experience />
      {/* <Articles /> */}
    </main>
  );
}

export default Content;
